module.exports = __webpack_public_path__ + "static/media/video2015.7bd734d9.png";